import { isPassiveSupported } from 'utils/passive-listner'

function handleUnfoldBehavior(event: Event): void {
  const $clickedElement = event.target as HTMLButtonElement
  const idOfContentToUnfold = $clickedElement.getAttribute('data-show-links')
  const $allElementsToUnfold = document.querySelectorAll<HTMLAnchorElement>(`[data-show-link=${idOfContentToUnfold}]`)
  $allElementsToUnfold.forEach(($singleElementToShow) => {
    $singleElementToShow.hidden = false
  })

  $clickedElement.hidden = true
}

const $allUnfoldButtons = document.querySelectorAll<HTMLButtonElement>('[data-show-links]')
$allUnfoldButtons.forEach(($singleButton) => {
  $singleButton.disabled = false
  $singleButton.addEventListener('click', handleUnfoldBehavior, isPassiveSupported ? { passive: true } : false)
})
